<script>
import ClubEmployeeDepartmentsAndTeamsRepository from '../../js/repository/ClubEmployeeDepartmentsAndTeamsRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        context: {
            type: String,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubEmployeeDepartmentsAndTeamsRepository.findByContext,
                params: [this.clubId, this.context],
                disableLoader: true,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
